import Component from '@glimmer/component';
import type { FormData, FormKey } from 'ember-headless-form';
import { type UserData } from '../../../types.ts';
import type { HeadlessFormComponentSignature } from 'ember-headless-form/components/headless-form';
import AnnotatedInput, {
  type WrFormAnnotedInputComponentSignature
} from '../annotated-input.gts';

export interface WrFormInputFieldComponentSignature<
  DATA extends UserData,
  KEY extends FormKey<FormData<DATA>> = FormKey<FormData<DATA>>
> {
  Element: WrFormAnnotedInputComponentSignature<DATA, KEY>['Element'];
  Args: {
    label?: string;
    confirmation?: string;
    blurOnWheel?: boolean;
    form: HeadlessFormComponentSignature<DATA, unknown>['Blocks']['default'][0];
    name: KEY;
  };
}

export default class WrFormInputFieldComponent<
  DATA extends UserData,
  KEY extends FormKey<FormData<DATA>> = FormKey<FormData<DATA>>
> extends Component<WrFormInputFieldComponentSignature<DATA, KEY>> {
  <template>
    <@form.Field @name={{@name}} as |field|>
      <div class='flex w-full flex-col'>
        {{#if @label}}
          <field.Label for={{field.id}}>{{@label}}</field.Label>
        {{/if}}

        <AnnotatedInput
          @name={{@name}}
          @field={{field}}
          @confirmation={{@confirmation}}
          @blurOnWheel={{@blurOnWheel}}
          ...attributes
        />
      </div>
    </@form.Field>
  </template>
}
